import React from 'react';
import './SubscriptionDetails.css';
import { FormControl, TextField } from '@mui/material';
import { CheckBox } from '@mui/icons-material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import ProfileServices from '../../Services/ProfileServices';
import Swal from 'sweetalert2';


interface ISubscriptionAmountDetails {
    productId: string;
    price: string;
    isMonitoring: boolean;
    planCode: string;
    planName: string;
    minTermMonths: number;
    sortOrder: number;
}

interface ISubscriptionDetails {
    alignment: string,
    subDetails: ISubscriptionAmountDetails[],
    accessToken: string,
    currentInput: string,
    newInput: string
    invalid: boolean,
    touched: boolean
}

class SubscriptionDetails extends React.Component<{}, ISubscriptionDetails> {

    constructor(props: any) {
        super(props);
        this.state = {
            subDetails: [],
            alignment: '',
            accessToken: '',
            currentInput: '',
            newInput: '',
            invalid: true,
            touched: false

        };
    }


    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getSubsriptionDetails();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getSubsriptionDetails() {
        ProfileServices.getACtiveSubscriptions(this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then((resp: ISubscriptionAmountDetails[]) => {
                    const plans = [...resp].sort((a, b) => a.sortOrder - b.sortOrder);
                    if (plans.length === 0) {
                        this.setState({ subDetails: plans });
                        return;
                    }
                    // keep the selected plan after a refresh, otherwise default to the first one
                    const selected = plans.find(x => x.planCode === this.state.alignment) ?? plans[0];
                    this.setState({
                        subDetails: plans,
                        alignment: selected.planCode,
                        currentInput: selected.price,
                        newInput: '',
                        touched: false,
                        invalid: true
                    });
                });
            }
        });
    }


    handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string | null
    ) => {
        if (newAlignment === null) return;
        const plan = this.state.subDetails.find(x => x.planCode === newAlignment);
        if (plan) {
            this.setState({ newInput: '', alignment: newAlignment, touched: false, invalid: true, currentInput: plan.price });
        }
    };

    insertNewSubscriptionAmount() {
        const plan = this.state.subDetails.find(x => x.planCode === this.state.alignment);
        let postData = {
            amount: `${this.state.newInput}`,
            planCode: this.state.alignment,
            isMonitoring: plan?.isMonitoring ?? false
        }
        ProfileServices.createNewSubscriptionProduct(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.text().then((resp) => {

                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated subscription amount successfully",
                    });

                })
            }
        })
    }

    onNewInputHandler(event: any) {
        const value = event.target.value;

        this.setState({ touched: true });
        // Allow clearing input
        if (value === '') {
            this.setState({ newInput: '', invalid: true });
            return;
        }

        // Allow only digits and a single optional dot
        const validPartialNumberPattern = /^\d*\.?\d{0,2}$/;
        if (!validPartialNumberPattern.test(value)) {
            return; // ignore invalid characters
        }

        // Set value no matter what (to support natural typing)
        this.setState({ newInput: value });

        // Check for actual valid number > 0
        const number = parseFloat(value);

        const isInvalid =
            isNaN(number) || number <= 0 || value.endsWith('.') || /^0+$/.test(value);

        this.setState({ invalid: isInvalid });

    }

    public render() {
        return (
            <div>
                {/* <div>
                    <label> Old Amount</label>
                    <input disabled value="$199.99" className='sub-input'></input>
                </div> */}
                <div style={{ display: 'flex', flexDirection: 'column', margin: '0 auto', alignItems: 'center' }}>
                    <FormControl sx={{ m: 1, width: '50%', textAlign: 'left' }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={this.state.alignment}
                            exclusive
                            onChange={this.handleChange}
                            aria-label="Platform"
                        >
                            {this.state.subDetails.map(plan => (
                                <ToggleButton key={plan.planCode} value={plan.planCode}>{plan.planName}</ToggleButton>
                            ))}
                        </ToggleButtonGroup>

                    </FormControl>
                    <FormControl id='et' sx={{ m: 1, width: '50%', textAlign: 'left', color: 'grey !important' }}>
                        <TextField id="outlined-basic" label="Old Subscription Amount " variant="outlined" value={`$${this.state.currentInput === '' ? '' : parseFloat(this.state.currentInput).toFixed(2)}`}
                            disabled
                            sx={{
                                '& .MuiInputBase-input': {
                                    textAlign: 'right',
                                    color: 'red !important',         // text color
                                    padding: '15px 14px' // aligns the input text
                                },
                                '& .MuiInputLabel-root.Mui-disabled': {
                                    color: 'grey !important',
                                },
                                // Optional: override the disabled text color too
                                '& .MuiInputBase-input.Mui-disabled': {
                                    color: 'grey',
                                },
                                // Optional: override the disabled border color
                                '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'grey',
                                },
                                textAlign: 'right'
                            }} />
                    </FormControl>

                    <FormControl id='et' sx={{ m: 1, width: '50%', textAlign: 'left' }}>
                        <TextField id="outlined-basic" label="New Subscription Amount" variant="outlined" type='number' value={this.state.newInput} sx={{
                            '& .MuiInputBase-input': {
                                textAlign: 'right',
                                padding: '15px 14px' // aligns the input text
                            },
                        }} onInput={(event) => this.onNewInputHandler(event)}
                            error={this.state.invalid && this.state.touched}
                            helperText={this.state.invalid && this.state.touched ? 'Invalid input entered' : ''} />

                    </FormControl>

                </div>
                <button className='Action-Btn-subDetails' onClick={(event) => this.insertNewSubscriptionAmount()} disabled={this.state.invalid}>Update</button>
            </div>

        )
    }

}
export default SubscriptionDetails;